import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';

import { useTranslation } from 'react-i18next';

// style
import tableIcons from '../../../components/table/MaterialTableIcon';

// Utils
import exportCsv from '../../../utils/export/Csv';

export default function DisasterDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('ตำบล'),
            title_export: t('ตำบล'),
            field: 'tambon_name',
            type: 'string',
            width: 100,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.tambon_name}`,
          },
          {
            title: t('อำเภอ'),
            title_export: t('อำเภอ'),
            field: 'amphoe_name',
            type: 'string',
            width: 100,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.amphoe_name}`,
          },
          {
            title: t('จังหวัด'),
            title_export: t('จังหวัด'),
            field: 'province_name',
            type: 'string',
            width: 100,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.province_name}`,
          },
        ]}
        data={datas}
        localization={{
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: isExport,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

DisasterDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
